import createPage from "@src/components/page"
import React from "react"
import { animated } from "@react-spring/web"
import * as styles from "./pageBooom.module.scss"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import frameImg from "@images/png/22.png"
import booomJson from "@images/lottieJson/booom.json"
import LottieControl from "@src/components/lottie"
import { imageCdnUrl } from "@src/utils/request"
import bgImg from "@images/2022/p12/48-100.jpg"
import defaultImg from "@images/2022/new/18aa.png"
import iconlogoImg from "@images/2022/p12/49.png"
import iconPcImg from "@images/2022/p12/50.png"
import iconBoomImg from "@images/2022/p12/51.png"
import classnames from "@src/utils/classnames"

const PageBooom = createPage(
  ({ data, offset }) => {
    const target = callYou(data)
    const anime1Styles = useEnteringTrail(4, offset, { type: "mlt" })
    const anime2Styles = useEnteringTrail(3, offset, { step: 0.7 })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.9 })
    const { gameData } = data
    const { amount, image, score } = gameData || {}

    const text = (() => {
      if (!gameData) {
        return (
          <>
            <animated.p style={anime2Styles[0]}>
              在今年的
              <br />
              BOOOM 游戏创作活动中
              <br />
              一共诞生了<b>211</b>款原创游戏
            </animated.p>
            <animated.p style={anime2Styles[1]}>
              有<b>700</b>位小伙伴加入了这场<span className="nowrap">创作</span>
            </animated.p>
            <animated.p style={anime2Styles[2]}>
              期待遇见更多热爱创作的<span className="nowrap">你们</span>
            </animated.p>
          </>
        )
      }

      return (
        <>
          <animated.p style={anime2Styles[0]}>
            今年的BOOOM活动
            <br />
            {target}创作了<b>{amount}</b>款游戏 在今年的
          </animated.p>
          <animated.p style={anime2Styles[1]}>
            一共获得了
            <br />
            <b>{score}</b>个点赞和关注
          </animated.p>
        </>
      )
    })()

    return (
      <>
        <div>
          <div className={styles.imageContainer}>
            <div className={styles.image}>
              <animated.img
                style={anime1Styles[0]}
                src={
                  image ? imageCdnUrl(image, { w: 558, h: 558 }) : defaultImg
                }
                alt="cover"
              />
              <animated.img
                style={anime1Styles[1]}
                src={iconPcImg}
                className={styles.iconPc}
                alt="icon"
              />
              <animated.img
                style={anime1Styles[2]}
                src={iconBoomImg}
                className={styles.iconBoom}
                alt="icon"
              />
              <animated.img
                style={anime1Styles[3]}
                src={iconlogoImg}
                className={styles.iconLogo}
                alt="icon"
              />
            </div>
          </div>
        </div>

        <div>{text}</div>

        <animated.div className="bottomText" style={anime3Styles[0]}>
          2022年BOOOM游戏创作挑战活动
          <br />
          {gameData
            ? "共700人参加并创作出211款游戏"
            : "最受欢迎的游戏是《喜丧》"}
        </animated.div>
      </>
    )
  },
  {
    className: classnames(styles.page, "pageLayout1"),
  }
)

export const pageBooomData = {
  key: "booom",
  bgImg,
  Page: PageBooom,
}

PageBooom.displayName = "PageBooom"
export default PageBooom
